import { useTranslation } from 'react-i18next';

const SettingsPage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <h3>{t('pages.settingsTitle')}</h3>
      <p>{t('pages.settingsDescription')}</p>
    </div>
  );
};

export default SettingsPage;
